import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BaseDashboard } from '../../models/dashboard/BaseDashboard';
import { FormSearch } from '../../models/dashboard/FormStatus';
import { UtilityService } from '../utility.service';
import { CustomerInvoiceFormView } from 'app/models/miscellaneous-billing/CustomerInvoiceFormView';
import { MassInvoiceCreationFormView } from 'app/models/miscellaneous-billing/MassInvoiceCreationFormView';
import { Configuration } from 'app/models/Configuration';

@Injectable({
	providedIn: 'root',
})
export class MassInvoiceCreationFormService {
	private readonly urlPath = `${environment.apiUrl}miscellaneous-billing/clients/`;

	constructor(private httpClient: HttpClient, private utilityService: UtilityService) {}

	createForm(clientId: string, request: any): Observable<any> {
		return this.httpClient.post<any>(`${this.urlPath}${clientId}/mass-invoice-creation-form`, request).pipe();
	}

	updateForm(clientId: string, id: string, request: any): Observable<any> {
		return this.httpClient.put<any>(`${this.urlPath}${clientId}/mass-invoice-creation-form/${id}`, request).pipe();
	}

	getForm(clientId: string, id: string): Observable<any> {
		return this.httpClient.get<any>(`${this.urlPath}${clientId}/mass-invoice-creation-form/${id}`).pipe();
	}

	rejectForm(clientId: string, id: string, rejectionReason: { reason: string; workflowId: number }): Observable<any> {
		return this.httpClient
			.post<any>(`${this.urlPath}${clientId}/mass-invoice-creation-form/${id}/decline`, rejectionReason)
			.pipe();
	}

	approveForm(clientId: string, id: string, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.urlPath}${clientId}/mass-invoice-creation-form/${id}/approve`, {
				userId,
			})
			.pipe();
	}

	getFormsFor(clientId: string, userId: string, search: FormSearch): Observable<BaseDashboard<any>> {
		let url = `${
			this.urlPath
		}${clientId}/mass-invoice-creation-form/users/${userId}?${this.utilityService.objectToQueryString(search)}`;
		return this.httpClient.get<BaseDashboard<any>>(url).pipe();
	}

	sendBack(clientId: string, id: string): Observable<any> {
		return this.httpClient.post<any>(`${this.urlPath}${clientId}/mass-invoice-creation-form/${id}/review`, {}).pipe();
	}

	uploadFile(clientId: string, id, file: File): Observable<HttpEvent<any>> {
		const formData: FormData = new FormData();
		formData.append('file', file);
		const req = new HttpRequest('POST', `${this.urlPath}${clientId}/mass-invoice-creation-form/${id}/docs`, formData, {
			reportProgress: true,
			responseType: 'json',
		});
		return this.httpClient.request(req);
	}

	deleteForm(clientId: string, id: string) {
		return this.httpClient.delete(`${this.urlPath}${clientId}/mass-invoice-creation-form/${id}`).pipe();
	}
	deleteDocument(clientId: string, formId: any, docId: any): Observable<any> {
		return this.httpClient.delete<any>(`${this.urlPath}${clientId}/mass-invoice-creation-form/${formId}/docs/${docId}`);
	}
	submitForApproval(clientId: string, id: any, userId: string): Observable<CustomerInvoiceFormView> {
		return this.httpClient
			.post<CustomerInvoiceFormView>(`${this.urlPath}${clientId}/mass-invoice-creation-form/${id}/approval`, {
				userId,
			})
			.pipe();
	}
	getLatestInvoicesByInvoiceType(clientId: string, invoiceTypeId: string): Observable<CustomerInvoiceFormView[]> {
		return this.httpClient
			.get<CustomerInvoiceFormView[]>(
				`${this.urlPath}${clientId}/mass-invoice-creation-form/invoice-type/${invoiceTypeId}/latest-invoices`
			)
			.pipe();
	}

	generateAllInvoices(clientId: string, formId: string): Observable<MassInvoiceCreationFormView> {
		return this.httpClient
			.post<MassInvoiceCreationFormView>(
				`${this.urlPath}${clientId}/mass-invoice-creation-form/${formId}/generate-all-invoices`,
				{}
			)
			.pipe();
	}
	getMassAutoInvoiceConfiguration(clientId: string): Observable<Configuration> {
		return this.httpClient
			.get<Configuration>(`${this.urlPath}${clientId}/mass-invoice-creation-form/auto-toggle-configuration`)
			.pipe();
	}
}
